module.exports = __webpack_public_path__ + "img/personalWebsite_v2.955f6012.png";